export const homeEn = {
  home: 'Home',
  about: 'About Us',
  projects: 'Our Services',
  statistics: 'Statistics',
  services: 'Services',
  contact: 'Contact Us',
  heroTitle: 'Al-Falah Association for Social and Cultural Works',
  associationName: 'Al-Falah Association',
  heroSubtitle: 'Circle Management System - Comprehensive platform for managing Quran memorization circles',
  adminLogin: 'Admin Login',
  teacherLogin: 'Teacher Login',
  parentLogin: 'Parent Login',
  aboutTitle: 'About Us',
  aboutText: 'Al-Falah Association for Social and Cultural Works is a charitable organization that aims to promote Islamic and cultural values in society. We focus on managing Quran memorization circles and providing educational and cultural services to the community.',
  readMore: 'Read More',
  projectsTitle: 'Our Main Services',
  project1Title: 'Student Management',
  project1Desc: 'Comprehensive system for managing student data and tracking their progress in Quran memorization with the ability to add and modify data.',
  project2Title: 'Grade Management',
  project2Desc: 'Comprehensive evaluation system for recording student grades and tracking their performance in circles with the ability to send reports to parents.',
  project3Title: 'Parent Communication',
  project3Desc: 'Effective communication platform between teachers and parents for sending messages, reports, and tracking student progress.',
  project4Title: 'Teacher Management',
  project4Desc: 'Comprehensive teacher management system with the ability to track their performance, evaluate them, and manage their schedules.',
  statsTitle: 'Association Statistics',
  statStudents: 'Students',
  statTeachers: 'Teachers',
  statCircles: 'Circles',
  statParents: 'Parents',
  servicesTitle: 'Our Services',
  service1Title: 'Quran Memorization Circles',
  service1Desc: 'Specialized circles for Quran memorization using modern and advanced methods',
  service2Title: 'Religious Education',
  service2Desc: 'Comprehensive educational programs for Islamic and jurisprudential sciences',
  service3Title: 'Cultural Activities',
  service3Desc: 'Diverse cultural events and programs to promote Islamic values',
  service4Title: 'Social Services',
  service4Desc: 'Social programs and initiatives to serve the community',
  footerText: 'All Rights Reserved - Athar Al-Quran Foundation',
  footerPoweredBy: 'Software used by: Al-Falah Association for Social and Cultural Works',
  privacyPolicy: 'Privacy Policy',
  contactUs: 'Contact Us',
  address: 'Address: Kingdom of Morocco',
  phone: 'Phone: +212 XX XXX XXXX',
  email: 'Email: info@alfalah.org',

  // Public contact form
  contactFormTitle: 'Send us a message',
  contactName: 'Full name',
  contactPhone: 'Phone',
  contactEmail: 'Email',
  contactSubject: 'Subject',
  contactMessage: 'Message',
  contactSend: 'Send message',
  contactSending: 'Sending...',
  contactPhoneOrEmailHint: 'Phone or email required',
  contactSuccess: 'Message sent successfully!',
  contactSuccessMsg: 'Thank you for contacting us. We will reply to you soon.',
  contactRefLabel: 'Your request number',
  contactErrName: 'Please enter your full name',
  contactErrSubject: 'Please enter the subject',
  contactErrMsg: 'Please enter your message (at least 10 characters)',
  contactErrPhoneOrEmail: 'Please enter a phone number or email',
  contactErrGeneric: 'An error occurred. Please try again.',
  contactErrLimit: 'Too many requests. Please try again later.',
  contactSendNew: 'Send another message',

  // Registration request
  inscriptionBtn: 'Registration Request',
  inscriptionTitle: 'Registration Request',
  inscriptionSubtitle: 'Fill in the information below to submit your registration request',
  inscriptionTypeLabel: 'Request type',
  inscriptionTypeParent: 'Parent',
  inscriptionTypeTeacher: 'Teacher',
  inscriptionParentModeNew: 'New parent',
  inscriptionParentModeExisting: 'Already registered parent',
  inscriptionName: 'Full name',
  inscriptionPhone: 'Phone',
  inscriptionEmail: 'Email (optional)',
  inscriptionGender: 'Gender',
  inscriptionGenderMale: 'Male',
  inscriptionGenderFemale: 'Female',
  inscriptionAddress: 'Address (optional)',
  inscriptionNotes: 'Notes (optional)',
  inscriptionExistingUsername: 'Username',
  inscriptionExistingPassword: 'Password',
  inscriptionChildrenTitle: 'Children information',
  inscriptionChildName: 'Student name',
  inscriptionChildLevel: 'Level',
  inscriptionChildHalqa: 'Circle',
  inscriptionChildNotes: 'Notes',
  inscriptionAddChild: '+ Add a child',
  inscriptionRemoveChild: 'Remove',
  inscriptionVerify: 'Verify',
  inscriptionVerifying: 'Verifying...',
  inscriptionChange: 'Change',
  inscriptionExistingChildren: 'Already registered children',
  inscriptionNewChildren: 'New children to register',
  inscriptionRenewSection: 'Children re-enrollment',
  inscriptionAlreadyRenrolled: 'Already re-enrolled',
  inscriptionSelected: 'Selected',
  inscriptionSelectRenroll: 'Re-enroll',
  inscriptionErrAtLeastOne: 'Select at least one re-enrollment or add a new child',
  inscriptionNoChildrenFound: 'No children found for this account',
  inscriptionTeacherTitle: 'Teacher information',
  inscriptionHalqa: 'Assigned circle',
  inscriptionExperience: 'Years of experience (optional)',
  inscriptionSpecialization: 'Specialization (optional)',
  inscriptionCertDate: 'Certification date (optional)',
  inscriptionSubmit: 'Submit request',
  inscriptionSubmitting: 'Submitting...',
  inscriptionSuccess: 'Request submitted successfully!',
  inscriptionSuccessMsg: 'Your request will be reviewed and we will contact you soon.',
  inscriptionRequestNumber: 'Your request number',
  inscriptionBack: 'Back',
  inscriptionErrName: 'Please enter the full name',
  inscriptionErrPhone: 'Please enter the phone number',
  inscriptionPhoneMissingHint: 'No phone number is registered on your account: please enter one to complete the request.',
  inscriptionErrHalqa: 'Please select a circle',
  inscriptionErrChildName: 'Please enter the student name',
  inscriptionErrGeneric: 'An error occurred. Please try again.',
  inscriptionErrLimit: 'Too many requests. Please try again later.',
  inscriptionErrCredentials: 'Incorrect credentials.',
  inscriptionErrParentMode: 'Please choose the parent request type',
  inscriptionErrCredentialsRequired: 'Please enter username and password',
  inscriptionLvlNursery: 'Nursery',
  inscriptionLvl1: '1st grade',
  inscriptionLvl2: '2nd grade',
  inscriptionLvl3: '3rd grade',
  inscriptionLvl4: '4th grade',
  inscriptionLvl5: '5th grade',
  inscriptionLvlPrep: 'Middle school',
  inscriptionHalqaListen: 'Listening circle',
  inscriptionHalqaMushaf: 'Mushaf circle',
  inscriptionHalqaReview: 'Review circle',
  inscriptionChild: 'Child',
  inscriptionOptional: 'optional',

  // Athar Foundation
  foundationName: 'Athar Al-Quran Foundation',
  foundationAbout: 'Foundation dedicated to spreading Quran teachings and facilitating its memorization',
  foundationContact: 'Contact the foundation',
  foundationEmail: 'atharalquran.org@gmail.com',
  foundationPhone: '+212767532742',
  foundationInfoTitle: 'About the Athar Al-Quran Foundation',
  foundationModalSubtitle: 'Free app for managing Quran memorization circles',
  foundationModalBody: 'A free application developed by the Athar Foundation for the Holy Quran, designed for all Quran memorization associations and institutes.\n\nThree independent spaces: Administrator, Teacher, and Parent.\n\nEnables management of students and teachers, tracking of memorization sessions and Quran progress, recording of grades and exams, financial management, and internal communication between all parties.\n\nAvailable in three languages: Arabic, French, and English.\n\nAvailable on Web, Android and iOS.',
  foundationEmailBtn: 'Email',
  foundationCallBtn: 'Call',
  foundationClose: 'Close',
  foundationComposeTitle: 'Write to the foundation',
  foundationComposeTo: 'To:',
  foundationYourName: 'Your name',
  foundationNamePlaceholder: 'Full name',
  foundationYourEmail: 'Your email',
  foundationEmailPlaceholder: 'email@example.com',
  foundationYourPhone: 'Phone',
  foundationPhonePlaceholder: '+212767532742',
  foundationSubject: 'Subject',
  foundationSubjectPlaceholder: 'Message subject',
  foundationMessage: 'Message',
  foundationMessagePlaceholder: 'Your message...',
  foundationSend: 'Send',
  foundationDefaultSubject: 'Message from El Falah platform',
  foundationErrRequired: 'Please fill in your name and message.',
  foundationWriteEmail: 'Write to the foundation',
};

